import moment from "moment";
import React, {Fragment, useState} from "react";
import {useDispatch} from "react-redux";
import {metricsActions} from "_actions/metrics.actions";
import {CircularProgress} from "@mui/material";
import _ from "lodash";
import {oEmbedActions} from "_actions";
import {isTimeToday, shouldDisplayInApp} from "_helpers";
import {isMetaSourcesForOEmbed} from "../Vote/Sections/BodySection/Conversation/OEmbed/EmbedUtils";
import styles from "./Utilities/Styles.module.css"

const MessageList = ({msgList, selectedChannels, setMessageLink, setMessageSource, loading, setMessageClicked}) => {
    const dispatch = useDispatch();
    const currentUser = JSON.parse(localStorage.getItem('user'));
    const orgId = currentUser._embedded.organization.id;
    const [selectedMessage, setSelectedMessage ] = useState(null);

    const onMessageSelect = ({messageId, agentId, link, msgSource, handleTypeName, externalParentId}) => {
        const msgSourceName = _.toString(_.get(msgSource, 'name', msgSource)).toLowerCase();
        handleTypeName = _.toString(handleTypeName).toLowerCase();
        const displayInApp = shouldDisplayInApp(msgSourceName, handleTypeName);
        if(isMetaSourcesForOEmbed(msgSourceName, displayInApp)) {
            dispatch(oEmbedActions.getMetaEmbed(messageId));
        }

        setMessageLink(link)
        setMessageSource(msgSourceName)
        setSelectedMessage(messageId)
        setMessageClicked(true)
        dispatch(metricsActions.getMetricsDetailConversation({
            messageId,
            agentId,
            organization: orgId,
            channels: selectedChannels,
            msgSource: msgSourceName,
            handleTypeName,
            externalParentId
        }))
    };


    return msgList.map((msg, index) => {
        return (
            <Fragment key={index}>
                {loading &&
                    <div className={styles.msgListLoaderContainer}>
                        <div className={styles.msgListInner}>
                            <CircularProgress sx={{color: '#003300'}}/>
                        </div>
                    </div>
                }
                {!loading &&
                    <div
                        role="button"
                        key={msg.messageId}
                        id={msg.messageId}
                        className={selectedMessage === msg.messageId ? styles.bgGray : styles.bgWhite}
                        onClick={() => onMessageSelect(msg)}
                    >
                    <div className="message-list-container" >
                        <div className="tms-truncate-2-lines message-list-text">
                            {msg.msg}
                        </div>
                        <div className="message-list-date" >
                            {isTimeToday(msg.date) ?
                                moment(msg.date).format('HH:mm a') :
                                moment(msg.date).format('DD-MMM-YYYY')}
                        </div>
                    </div>
                </div>
                }
            </Fragment>
        )
    })
}

export default MessageList